import axios, { AxiosResponse } from 'axios'
import {
  AvaliacoesQueryResponse,
  FormularioAtendimentoDtoAssinatura,
  FormularioAtendimentoDtoAssinaturaLote,
} from './_models'
import { ArquivoDto } from '../../../atendimento/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const AVALIACOES_RESPONSAVEL_URL = `${API_URL}/atendimentos/formulario/responsavel`

/* export const getAvaliacoesUnsigned = (query: string): Promise<AvaliacoesQueryResponse> => {
  console.log(query)
  return axios
    .get(`${AVALIACOES_URL}/pendente?${query}`)
    .then((d: AxiosResponse<AvaliacoesQueryResponse>) => d.data)
} */

export const getAvaliacoesUnsigned = (query: string): Promise<AvaliacoesQueryResponse> => {
  return axios
    .get(`${AVALIACOES_RESPONSAVEL_URL}/assinar?${query}`)
    .then((d: AxiosResponse<AvaliacoesQueryResponse>) => d.data)
}

/**
 * Assinatura de formulários de atendimento em lote
 * @param formularioAtendimento formularioAtendimento
 * @returns AssinaturaLoteResultadoDto
 */
export const signAvaliacaoLote = (
  formularioAtendimento: FormularioAtendimentoDtoAssinaturaLote
): Promise<void> => {
  return axios.put(`${AVALIACOES_RESPONSAVEL_URL}/assinar`, formularioAtendimento)
}

/**
 * Assinatura de formulário de atendimento
 * @param formularioAtendimento FormularioAtendimentoDtoAssinatura
 * @returns ArquivoDto
 */
export const signAvaliacao = (
  formularioAtendimento: FormularioAtendimentoDtoAssinatura
): Promise<ArquivoDto> => {
  return axios
    .patch(`${AVALIACOES_RESPONSAVEL_URL}/assinar`, formularioAtendimento)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}
